// Public content pages: no map here, so this bundle stays tiny.
import "../css/pages.css";
import { start } from "./pages.js";
import { startRenderStatus } from "./render-status.js";
import { preserveAdminHash, startModelHealth } from "./admin-tools.js";
import { startConditions } from "./fishing-conditions.js";
import { startPublicStatus } from "./public-status.js";
import { setupAnalytics } from "./analytics.js";
import { startAnalyticsUi } from "./analytics-ui.js";
import { startMailingListTimes } from "./mailing-list-times.js";
import "../css/analytics.css";
import "../css/fishing-conditions.css";
import "../css/water-column.css";
import "../css/current-profile.css";

if (document.body?.classList.contains("site")) {
  start();
  startConditions();
  startPublicStatus();
  startRenderStatus();
  preserveAdminHash();
  startModelHealth();
  startAnalyticsUi();
}

startMailingListTimes();
setupAnalytics();
